import { render, staticRenderFns } from "./WxPay.vue?vue&type=template&id=5bf9fd5d&scoped=true&"
import script from "./WxPay.vue?vue&type=script&lang=ts&"
export * from "./WxPay.vue?vue&type=script&lang=ts&"
import style0 from "./WxPay.vue?vue&type=style&index=0&id=5bf9fd5d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf9fd5d",
  null
  
)

export default component.exports